module.exports = __webpack_public_path__ + "img/two.be5030ca.webp";